// ── V145: 새 버전이 나왔을 때 새로고침 버튼 ─────────────────────────────────
// 화면을 켜 둔 채로 배포되면 옛 버전이 계속 돈다. serviceWorkerRegistration이
// 새 버전을 받으면 'semfit-update-ready' 신호를 보내고, 여기서 화면 아래에 띄운다.
// 자동으로 새로고침하지 않는다 — 작성 중인 발주서 수량은 저장 전까지 화면에만 있다.
import React, { useEffect, useState } from 'react';
import { UPDATE_EVENT } from '../serviceWorkerRegistration';

const readLang = () => {
  try { return localStorage.getItem('semfit_lang') === 'zh' ? 'zh' : 'ko'; } catch { return 'ko'; }
};

export default function UpdateBanner() {
  const [show, setShow] = useState(() => typeof window !== 'undefined' && !!window.__semfitUpdateReady);
  const [lang, setLang] = useState(readLang);

  useEffect(() => {
    const on = () => { setLang(readLang()); setShow(true); };
    window.addEventListener(UPDATE_EVENT, on);
    if (window.__semfitUpdateReady) on();
    return () => window.removeEventListener(UPDATE_EVENT, on);
  }, []);

  if (!show) return null;
  const zh = lang === 'zh';
  return (
    <div data-update-banner role="status"
      style={{ position: 'fixed', left: '50%', bottom: 16, transform: 'translateX(-50%)', zIndex: 100000,
               width: 'min(560px, calc(100vw - 24px))', boxSizing: 'border-box',
               display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
               padding: '12px 14px', borderRadius: 14, background: '#18181B', color: '#fff',
               boxShadow: '0 8px 24px rgba(0,0,0,0.25)', fontSize: 14 }}>
      <div style={{ flex: '1 1 240px', minWidth: 0, lineHeight: 1.4 }}>
        <div style={{ fontWeight: 800 }}>{zh ? '🔄 有新版本' : '🔄 새 버전이 나왔어요'}</div>
        <div style={{ fontSize: 12, opacity: 0.8 }}>
          {zh ? '刷新后生效。正在填写订货单的话，请先保存或发送。' : '새로고침하면 적용돼요. 발주서를 작성 중이면 먼저 저장·전송하세요.'}
        </div>
      </div>
      <button data-update-later type="button" onClick={() => setShow(false)}
        style={{ padding: '8px 12px', borderRadius: 10, border: '1px solid #52525B', background: 'transparent', color: '#D4D4D8', fontWeight: 700, cursor: 'pointer' }}>
        {zh ? '稍后' : '나중에'}
      </button>
      <button data-update-reload type="button" onClick={() => window.location.reload()}
        style={{ padding: '8px 14px', borderRadius: 10, border: 'none', background: '#FF6F0F', color: '#fff', fontWeight: 800, cursor: 'pointer' }}>
        {zh ? '刷新' : '새로고침'}
      </button>
    </div>
  );
}
